<template>
  <van-sticky>
    <div class="title-bar">
      <slot name="left-content" />
      <div class="project-list">
        <van-dropdown-menu title-class="titleClass">
          <van-dropdown-item v-model="currentProjectId" :options="projectList" @change="changeSelectProject" />
        </van-dropdown-menu>
        <div class="content">
          <slot name="content" />
        </div>
      </div>
      <div class="right-content" @click="handleClick">
        <slot />
      </div>
    </div>
  </van-sticky>
</template>

<script>
import { mapGetters } from 'vuex'
import worker from '@/api/worker'
import store from '../../_vuex/index'
export default {
  name: 'TitleBar',
  data() {
    return {
      currentProjectId: 0,
      projectList: []
    }
  },
  computed: {
    ...mapGetters(['getProjectList', 'getSelectProject'])
  },
  // watch: {
  //   getSelectProject(val) {
  //     console.log('watch', val);
  //     this.currentProjectId = val.id

  //   }
  // },
  created() {
    // this.$on('right-click', function (msg) {
    //   console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa', msg)
    // })
  },
  mounted() {
    worker.projectlist().then(res => {
      if (res.data.code === 200) {
        res.data.data.forEach(el => {
          el.projectId = el.id
        });
        console.log(1);
        store.commit('setProjectList', res.data.data)
        if (this.getSelectProject) {
          res.data.data.forEach(el => {
            if (el.id === this.getSelectProject.id) {
              this.currentProjectId = el.id
              this.$store.commit('setSelectProject', el)
            } else if (this.getSelectProject === null) {
              this.$store.commit('setSelectProject', res.data.data[0])
            }
          });
        } else {
          this.$store.commit('setSelectProject', res.data.data[0])
        }
        console.log(3);
        this.getProject()
      }
    })
  },
  methods: {
    /**
     * 获取当前选择工地和工地列表
     */
    getProject() {
      this.getProjectList.forEach(item => {
        this.projectList.push({ text: item.name, value: item.id })
      })
      // 设置当前选择项目id
      this.currentProjectId = this.getSelectProject ? this.getSelectProject.id : this.getProjectList[0].id
      this.$emit('change', this.getProjectList[0].id)
    },
    /**
     * 改变当前选择工地
     * @param projectId
     */
    changeSelectProject(projectId) {
      const project = this.getProjectList.filter(item => item.id === projectId)[0]
      if (project !== null) {
        this.$store.commit('setSelectProject', project)
        this.$emit('change', project.id)
      }
    },
    handleClick(e) {
      this.$emit('right-click', e)
    }
  }
}
</script>

<style lang="scss" scoped>
.title-bar {
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: row;
  background-color: #ffffff;

  /*height: 48px;*/
  .project-list {
    flex: 1;
    display: flex;
    align-items: center;

    .content {
      text-align: right;
      flex: 1;
    }
  }

  .right-content {
    height: 100%;
    padding-right: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 25px;
  }
}

.titleClass {
  color: #fff7cc;
  font-weight: bold;
}
</style>
<style>
.title-bar .van-dropdown-menu__bar {
  box-shadow: none;
}

.title-bar .van-dropdown-menu {
  width: 200px;
}

.title-bar .van-dropdown-menu__item {
  justify-content: end;
}
</style>



// WEBPACK FOOTER //
// src/components/TitleBar/index.vue